import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* Original name @uswitch/trustyle.breadcrumbs */
import * as React from 'react';
import { Themed, useThemeUI } from 'theme-ui';
import { TruHome } from '@uswitch/spark-icons/tru';
import { Palette, usePalette, Link } from '@uswitch/ev-core/react';
import { path } from '@uswitch/ev-utils/obj';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var lookup = function lookup(variant) {
  return variant === 'base' ? 'elements.breadcrumbs.base' : "elements.breadcrumbs.variants.".concat(variant);
};

var HomeIcon = function HomeIcon(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'base' : _ref$variant;

  var _usePalette = usePalette(),
      textColor = _usePalette.textColor;

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var iconColor = path("".concat(lookup(variant), ".homeIcon.color").split('.'), theme);
  return _jsx("div", {
    sx: {
      display: 'inline-block',
      width: '1.25em',
      height: '1em',
      variant: "".concat(lookup(variant), ".homeIcon")
    },
    children: _jsx(TruHome, {
      color: textColor || iconColor
    })
  });
};

var MobileBreadcrumbs = function MobileBreadcrumbs(_ref2) {
  var crumbs = _ref2.crumbs,
      _ref2$customBackIcon = _ref2.customBackIcon,
      customBackIcon = _ref2$customBackIcon === void 0 ? '<' : _ref2$customBackIcon,
      customHomeIcon = _ref2.customHomeIcon,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'base' : _ref2$variant,
      homePath = _ref2.homePath;
  var BackIcon = typeof customBackIcon === 'function' ? customBackIcon : function () {
    return customBackIcon;
  };
  var href, backTo;

  if (crumbs.length) {
    var _lastCrumb$fields, _lastCrumb$fields2;

    var lastCrumb = crumbs[crumbs.length - 1];
    href = (_lastCrumb$fields = lastCrumb.fields) === null || _lastCrumb$fields === void 0 ? void 0 : _lastCrumb$fields.path;
    backTo = (_lastCrumb$fields2 = lastCrumb.fields) === null || _lastCrumb$fields2 === void 0 ? void 0 : _lastCrumb$fields2.displayText;
  } else {
    href = homePath;
    backTo = customHomeIcon || _jsx(HomeIcon, {
      variant: variant
    });
  }

  return _jsxs(Palette, {
    as: Link,
    sx: {
      display: 'inline-block',
      color: 'inherit',
      textDecoration: 'none',
      borderBottom: 0,
      fontSize: 'xxs',
      variant: "".concat(lookup(variant), ".mobileLink")
    },
    px: {
      color: 'textColor'
    },
    href: href,
    children: [_jsx("span", {
      sx: {
        marginRight: 'xxs',
        verticalAlign: customBackIcon === 'function' ? 'middle' : undefined
      },
      children: _jsx(BackIcon, {})
    }), backTo]
  });
};

var DesktopBreadcrumbs = function DesktopBreadcrumbs(_ref3) {
  var crumbs = _ref3.crumbs,
      title = _ref3.title,
      _ref3$customSeparator = _ref3.customSeparator,
      customSeparator = _ref3$customSeparator === void 0 ? '>' : _ref3$customSeparator,
      customHomeIcon = _ref3.customHomeIcon,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'base' : _ref3$variant,
      homePath = _ref3.homePath;
  var liStyling = {
    display: 'inline'
  };
  var anchorStyling = {
    color: 'inherit',
    stroke: 'inherit',
    textDecoration: 'none',
    borderBottom: 0,
    variant: "".concat(lookup(variant), ".a"),
    ':visited': {
      color: 'inherit'
    }
  };
  var Separator = typeof customSeparator === 'function' ? customSeparator : function () {
    return customSeparator;
  };
  var separatorStyling = {
    display: 'inline-block',
    marginX: 'xs',
    verticalAlign: customSeparator === 'function' ? 'middle' : undefined
  };
  return _jsxs(Palette, {
    as: Themed.ul,
    px: {
      color: 'textColor'
    },
    sx: {
      listStyleType: 'none',
      paddingLeft: 0,
      fontSize: 'xxs',
      marginY: 0,
      variant: "".concat(lookup(variant), ".main")
    },
    children: [_jsxs("li", {
      sx: liStyling,
      children: [_jsx(Link, {
        sx: anchorStyling,
        href: homePath,
        children: customHomeIcon || _jsx(HomeIcon, {
          variant: variant
        })
      }), crumbs.length || title ? _jsx("span", {
        sx: separatorStyling,
        children: _jsx(Separator, {})
      }) : null]
    }), crumbs.map(function (_ref4, i) {
      var _ref4$fields = _ref4.fields,
          fields = _ref4$fields === void 0 ? {} : _ref4$fields;
      return _jsxs("li", {
        sx: liStyling,
        children: [_jsx(Link, {
          sx: anchorStyling,
          href: fields.path,
          children: fields.displayText
        }), (i !== crumbs.length - 1 || title) && _jsx("span", {
          sx: separatorStyling,
          children: _jsx(Separator, {})
        })]
      }, i);
    }), title ? _jsx(Palette, {
      as: Themed.li,
      px: {
        color: 'textColor'
      },
      sx: _objectSpread(_objectSpread({}, liStyling), {}, {
        variant: "".concat(lookup(variant), ".title")
      }),
      children: title
    }) : null]
  });
};

var Breadcrumbs = function Breadcrumbs(_ref5) {
  var _crumbs$0$fields;

  var _ref5$crumbs = _ref5.crumbs,
      crumbs = _ref5$crumbs === void 0 ? [] : _ref5$crumbs,
      title = _ref5.title,
      _ref5$customSeparator = _ref5.customSeparator,
      customSeparator = _ref5$customSeparator === void 0 ? '>' : _ref5$customSeparator,
      _ref5$customBackIcon = _ref5.customBackIcon,
      customBackIcon = _ref5$customBackIcon === void 0 ? '<' : _ref5$customBackIcon,
      customHomeIcon = _ref5.customHomeIcon,
      _ref5$variant = _ref5.variant,
      variant = _ref5$variant === void 0 ? 'base' : _ref5$variant,
      _ref5$homePath = _ref5.homePath,
      homePath = _ref5$homePath === void 0 ? '/' : _ref5$homePath,
      className = _ref5.className;

  if (crumbs.length && ((_crumbs$0$fields = crumbs[0].fields) === null || _crumbs$0$fields === void 0 ? void 0 : _crumbs$0$fields.path) === homePath) {
    crumbs = crumbs.slice(1);
  }

  return _jsxs("div", {
    sx: {
      variant: "".concat(lookup(variant), ".wrapper")
    },
    className: className,
    children: [_jsx("div", {
      sx: {
        display: ['block', 'none'],
        paddingTop: 'sm'
      },
      children: _jsx(MobileBreadcrumbs, {
        crumbs: crumbs,
        customBackIcon: customBackIcon,
        customHomeIcon: customHomeIcon,
        variant: variant,
        homePath: homePath
      })
    }), _jsx("div", {
      sx: {
        display: ['none', 'block'],
        paddingTop: 'sm'
      },
      children: _jsx(DesktopBreadcrumbs, {
        crumbs: crumbs,
        title: title,
        customSeparator: customSeparator,
        customHomeIcon: customHomeIcon,
        variant: variant,
        homePath: homePath
      })
    })]
  });
};

export default Breadcrumbs;
//# sourceMappingURL=index.js.map